package br.com.vvrefeicoes.portal.domain.model

data class UnitMargin(
    val name: String,
    val marginPercent: Double,
)
